import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api/api.service';
import { AuthService } from '../auth/auth.service';
import { ButtonModel } from './models/button.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ButtonsService {
  private _spiritualMapping = {
    v1: 'Abenteuergeist',
    v2: 'besondere Augenblicke',
    v3: 'Bildung',
    v4: 'Dankbarkeit',
    v5: 'Farbe im Leben',
    v6: 'Freude',
    v7: 'Gerechtigkeit',
    v8: 'Glauben an das Gute',
    v9: 'große Träume',
    v10: 'Herzlichkeit',
    v11: 'Hoffnung',
    v12: 'Ja',
    v13: 'Kind in mir',
    v14: 'Leichtigkeit',
    v15: 'Liebe',
    v16: 'magische Schlüssel',
    v17: 'Musik im Leben',
    v18: 'Phantasie',
    v19: 'Poesie im Leben',
    v20: 'Solidarität',
    v21: 'Vertrauen',
    v22: 'wahre Gefühle',
    v23: 'Wahrheit',
    v24: 'Zeit mit Kindern'
  };

  constructor(
    private authService: AuthService,
    private apiService: ApiService) {
  }

  public factory(data): ButtonModel {
    const model = new ButtonModel();

    model.design = data.design;
    model.spiritual = data.spiritual;
    model.spiritualText = this.mapSpiritual(data.spiritual);
    model.value = data.value;
    model.code = data.code;
    
    if (data.scannedCount) {
      model.scannedCount = data.scannedCount;
    }
    
    if (typeof data.gotByVoucher !== 'undefined') {
      model.gotByVoucher = data.gotByVoucher;
    }
    
    if (typeof data.greetingsMessage !== 'undefined') {
      model.greetingsMessage = data.greetingsMessage.replace(/(\\r\\n)|([\r\n])/gmi, '<br/>');
      
      if (typeof data.giverFirstName !== 'undefined' && typeof data.giverLastName !== 'undefined') {
        model.giverFirstName = data.giverFirstName;
        model.giverLastName = data.giverLastName;
      }
    }
    
    if (data.user) {
      model.user = this.authService.userFactoryFromResponse(data.user, true);
    }

    return model;
  }

  public mapSpiritual(key: string) {
    return this._spiritualMapping[key];
  }

  public getMine(): Observable<ButtonModel[]> {
    const subject = new Subject<ButtonModel[]>();

    if (this.authService.currentUser && this.authService.currentUser.token) {
      const httpOptions = {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.authService.currentUser.token
        })
      };

      this.apiService.get('buttons/mine-all', httpOptions)
        .subscribe(
          (results) => {
            const parsedResults = [];

            if (results.buttons) {
              for (const result of results.buttons) {
                parsedResults.push(this.factory(result));
              }
            }

            subject.next(parsedResults);
            subject.complete();
          },
          (err) => {
            subject.error(err);
          }
        );
    } else {
      subject.error('Invalid user token');
    }

    return subject.asObservable();
  }

  public getOne(code: string): Observable<ButtonModel> {
    const subject = new Subject<ButtonModel>();

    this.apiService.get('buttons/' + code)
      .subscribe(
        (result) => {
          if (typeof result.button === 'undefined') {
            subject.error('not found');
          } else {
            result.button.user = result.user;

            subject.next(this.factory(result.button));
            subject.complete();
          }
        },
        (err) => {
          subject.error(err);
        }
      );

    return subject.asObservable();
  }

  public getLatest(offset: number, limit: number): Observable<ButtonModel[]> {
    const subject = new Subject<ButtonModel[]>();

    this.apiService.get(`buttons/latest-all/${offset}/${limit}`)
      .subscribe(
        (response) => {
          const parsedResults = [];

          if (response.buttons) {
            for (const result of response.buttons) {
              result.button.user = result.user;
              
              if (result.scannedCount) {
                result.button.scannedCount = result.scannedCount;
              }

              parsedResults.push(this.factory(result.button));
            }
          }

          subject.next(parsedResults);
          subject.complete();
        }
      );

    return subject.asObservable();
  }
}


// WEBPACK FOOTER //
// ./src/app/buttons/buttons.service.ts